module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid-Stretches-Revitalize.3cb98819.jpg";